export default "__VITE_ASSET__DNHw8rQx__"